
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"; 
import Login from "./pages/login"; 
import Register from "./pages/register"; 
import Dashboard from "./pages/home"; 
import FieldPage from "./pages/fieldpage"; 
import SubjectPage from "./pages/subjectpage";
import ReportPage from "./pages/reportpage";
import UserDashboard from "./pages/dashboard";
import Profile from "./components/Dashboard/ProfileView";
import MyReports from "./components/Dashboard/MyReports";
import MySubjects from "./components/Dashboard/MySubjects";
import DashboardIdeas from "./components/Dashboard/MyFieldIdeas";
import ReportDownloader from "./components/Dashboard/ReportDownloader";
import AddUser from "./components/Dashboard/AddUser";
import UserList from "./components/Dashboard/UserList";
import UserTasks from "./components/Dashboard/UserTasks";
import TaskManagement from "./components/Dashboard/TaskManagement";
import Layout from "./components/Layout";
import DashboardLayout from "./components/DashboardLayout";
import SubmitIdeaPage from "./pages/submitideapage";
import NotFound from "./pages/404notfound";
import WorkHours from "./pages/workhour";
import MyMonthlyOverview from "./components/Dashboard/MyMonthlyOverview";

import Cookies from "js-cookie"; 
// Function to check authentication 
const isAuthenticated = () => { 
    return !!Cookies.get("access_token"); // Returns true if token exists 
}; 
const App = () => { 
  return ( 
  <Router> 
    <Routes> {/* Public Routes */} 
      <Route path="/" element={<Login />} /> 
      <Route path="/login" element={<Login />} /> 
      <Route path="/register" element={<Register />} />
      <Route element={<Layout />}>
      <Route path="/home" element={<Dashboard />} /> 
      <Route path="/submit-idea" element={<SubmitIdeaPage />} />
      <Route path="/field/:id" element={<FieldPage />} />
      
      <Route path="/subject/:id" element={<SubjectPage />} />
      <Route path="/report/:id" element={<ReportPage />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route path="profile" element={<Profile />} />
        <Route path="reports" element={<MyReports />} />
        <Route path="subjects" element={<MySubjects />} />
        <Route path="add-user" element={<AddUser />} />
        <Route path="ideas" element={<DashboardIdeas />} />
        <Route path="download-reports" element={<ReportDownloader />} />
        <Route path="workhours" element={<WorkHours />} />
        <Route path="users" element={<UserList />} />
        <Route path="activities" element={<MyMonthlyOverview />} />
        <Route path="tasks" element={<UserTasks />} />

        <Route path="task-management" element={<TaskManagement />} />


      </Route>
      <Route path="*" element={<NotFound />} />

      </Route>
           </Routes>
            </Router> 
            ); 
          }; 

export default App; 

